export default __webpack_public_path__ + "static/media/img-0379-switzerland-full-face.01c4d027.png";